module.exports = __webpack_public_path__ + "img/a2.d9007d75.jpg";